<div class="user-profile">
    <f-button [text]="rootScope.name" type="button" variant="progressive" (click)="showDataCard()" class="pink">
    </f-button>
    <div class="user-profile-dialog" *ngIf="finalShowProfileCardVal && rootScope.loadUI">
        <f-data-card>

            <div class="flex justify-flex-end close-button">
                <button mat-icon-button aria-label="" (click)="closeDataCard()">
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                </button>
            </div>
            <h4 class="my-account-title"> My Account</h4>
            <p class="name"> {{rootScope.firstName + " " + rootScope.lastName}}</p>


            <!-- Database Selector code start here hidden for prof deployment  -->
            <div class="database-selector profile-link" *ngIf="!this.rootScope.isCarePortalProd"  [attr.tabIndex]="-1">
            
                <p title="Database Selector" class="tool-tip"
                [matTooltip]="rootScope.checkCallOrChat()?'Database Selector is only accessible in Research Mode':''"
                matTooltipClass="left user-profile"
                matTooltipPosition="left"
                matTooltipHideDelay="0"                  
                aria-label="Button that shows a tooltip"  [attr.tabIndex]="-1">
                    <span *ngIf="rootScope.checkCallOrChat()">                         
                        <f-icon class="gap" icon-config='{"iconName": "database", "iconType": "light", "iconSize": "s"}'></f-icon>
                    </span>
                    <span *ngIf="!rootScope.checkCallOrChat()"> 
                        <f-icon class="gap" icon-config='{"iconName": "database", "iconType": "light", "iconSize": "s"}'></f-icon>                        
                        </span>
                    <f-button text="Database Selector" title="Database Selector" [disabled]="rootScope.checkCallOrChat()" [attr.tabIndex]="-1"
                        [ngClass]="{'disabledLink':rootScope.checkCallOrChat()}"
                        type="button" variant="action" class="no-border" (click)="openDatabaseSelector()">
                    </f-button>
                </p>
            </div>


            <div class="section-divider" *ngIf="rootScope?.batchAlertData?.isBatchAlertAccess ||
            this.rootScope?.simulationData?.isSimulationAccess"></div>

            <!-- Batch alert code start here  -->
            <div *ngIf="rootScope.batchAlertData?.isBatchAlertAccess" class="batch-alert profile-link toggle-CTA hide1">
                <div title="Batch Alerts"><f-icon icon-config='{"iconName": "bell", "iconType": "light", "iconSize": "s"}' class="gap"></f-icon>
                  <span>Batch Alerts</span>
                </div>

                <!-- add "disabledLink" class with "toggle-btn" to make it disable  -->
                <div class="toggle-btn" [ngClass]="rootScope.simulationData.isSimulationToggleOn ||  rootScope.isLiveCall || rootScope.checkLiveChatAccount() ? 'disableBtn' : ''">

                    
                    <f-toggle-switch  [isOn]="rootScope.batchAlertData.isBatchAlertToggleOn" 
                    [disabled]="rootScope.simulationData.isSimulationToggleOn ||  rootScope.isLiveCall || rootScope.checkLiveChatAccount()" (toggleSwitchClicked)="onToggleChangeBatchAlert($event)"
                    isFor="Use the Toggle key to turn the Batch Alert On/Off.">
                    </f-toggle-switch>
                </div>
            </div>

            <!-- simulation-mode code start here  -->
            <div class="simulation-mode toggle-CTA hide1" *ngIf="this.rootScope?.simulationData?.isSimulationAccess">
                <div class="sm-selector">
                    <f-tooltip content="To access Simulation Mode, user can't be registered to ALIS organization."
                        position="left" variant="icon" trigger-event-type="hover" [iconConfig]="iconConfig2"></f-tooltip>
                    <span class="sm-title"> Simulation Mode </span>
                    <div class="toggle-btn" [ngClass]="checkTogglediasabled() ||  rootScope.batchAlertData.isBatchAlertToggleOn ? 'disableBtn' : ''">

                        <f-toggle-switch  [isOn]="this.rootScope.simulationData.isSimulationToggleOn" 
                    [disabled]="checkTogglediasabled() ||  rootScope.batchAlertData.isBatchAlertToggleOn" (toggleSwitchClicked)="onToggleChange($event)">
                    </f-toggle-switch>
                    </div>
                </div>
                


               
            </div>

            <div class="section-divider" *ngIf="rootScope?.batchAlertData?.isBatchAlertAccess ||
            this.rootScope?.simulationData?.isSimulationAccess"></div>

            <p class="profile-link help">
                <f-icon icon-config='{"iconName": "circle-question", "iconType": "light", "iconSize": "s"}' class="gap"></f-icon>
                <f-button text="Help" title="Help" type="button" variant="action" class="no-border" (click)="openHelpPdf()">
                </f-button>
            </p>

            <div class="section-divider" *ngIf="!rootScope?.batchAlertData?.isBatchAlertAccess &&
            !this.rootScope?.simulationData?.isSimulationAccess"></div>

            <p class="profile-link logout"><f-icon icon-config='{"iconName": "arrow-right-from-bracket", "iconType": "light", "iconSize": "s"}' class="gap"></f-icon>
                <f-button text="Logout" title="Logout" type="button" variant="action" class="no-border" (click)="userLogout()">
                </f-button>
            </p>
            <div class="text-align-center disclaimer">
                <div class="version-text"> {{"Version " + showAngularVersion}}</div>
                <div> &copy; {{currentYear}} Alight. All rights reserved.</div>
                <div class="trademark">&reg; Alight is a registered trademark of Alight Solutions, LLC</div>
                <div class="link"><button class='navlink' title="Privacy and Policies"
                        (click)="openPrivacyLink()">Privacy and
                        Policies</button></div>
                <div class="timestamp"> {{showTimeStamp | date:'medium'}} || {{showFullHash.slice(-8)}}</div>
            </div>
        </f-data-card>
    </div>
</div>